













































import { Component, Vue, ProvideReactive } from 'vue-property-decorator';
import * as api from '@/api';
import userModel from '@/store/modules/user';
import SessionModule from '@/store/modules/session';
import { Dialog } from 'vant';
import LocalForm from './localForm.vue';
import NetworkForm from './NetworkForm.vue';
import { getUrlParam } from '@/utils/util';
import UserModule from '@/store/modules/user';

@Component({ components: { LocalForm, NetworkForm } })
export default class LoginComponent extends Vue {
  isDispaly: boolean = false;

  isHaveNetworkAccount: boolean = true;

  authKey: string = '';

  classId: string = '';

  opreateType: string = '';

  classType: string = '';

  @ProvideReactive() wxOpenId = '';
  @ProvideReactive() Signature = '';

  mounted() {
    UserModule.LogOut();
    this.authKey = getUrlParam('authKey');
    this.classId = getUrlParam('classId');
    this.opreateType = getUrlParam('opreateType');
    this.classType = getUrlParam('classType');

    if (process.env.NODE_ENV === 'production') {
      if (this.authKey.length < 1) {
        this.getAuthUrl();
      } else {
        this.automaticLogon();
      }
    }
  }

  localRegister(data) {
    this.getInfo(data);
  }

  async getInfo(data: any) {
    const time = new Date(new Date().getTime() + data.data.expires_in * 1000);
    await userModel.SetData({
      refresh_token: '',
      expires_time: time,
      token: data.data.access_token,
    });
    await userModel.SetUserInfo(data);
    SessionModule.ACTIVE_USER({
      userId: data.data.userId,
      deptName: data.data.deptName,
      userName: data.data.phone,
      name: data.data.name,
      token: data.data.access_token,
      refresh_token: '',
      expires_time: time,
      userType: data.data.userType,
      openId: data.openId,
    });
    //const to = this.$route.query.redirect && this.$route.query.redirect !== '/404' ? this.$route.query.redirect : '/home';

    this.$router.push({
      name: 'home',
      query: {
        classId: this.classId,
        opreateType: this.opreateType,
        classType: this.classType,
      },
    });
  }

  async automaticLogon() {
    try {
      const result: any = await api.AccountApp.autoLoginByAuthkey_POST({ authKey: this.authKey });
      if (result.success) {
        this.Signature = result.data.signature;
        this.wxOpenId = result.data.openId;
        if (result.data.success) {
          const data: any = result?.data;
          this.getInfo(data);
        } else {
          Dialog.alert({
            message: result.data.message,
            title: '错误提示',
          });
        }
      }
    } catch (error) {
      Dialog.alert({
        title: '错误',
        message: error.toString(),
      });
    }
  }

  async getAuthUrl() {
    try {
      const result = await api.AccountApp.getAuthUrl_GET({
        classId: this.classId,
        opreateType: this.opreateType,
        classType: this.classType,
      });
      const url = result.data as string;
      if (url != null) {
        location.href = url + '&timestamp=' + new Date().getTime() + Math.random();
      } else {
        Dialog.alert({
          message: '未获取到授权结果跳转Url',
          title: '提示',
        });
      }
    } catch (error) {
      Dialog.alert({
        message: error.toString(),
        title: '提示',
      });
    }
  }

  changeHaveNetworkAccount(value: boolean) {
    this.isHaveNetworkAccount = value;
  }

  beforeCreate() {}
}
